import {CSSProperties, FC} from 'react';


export interface IIconCartBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconCartBmw: FC<IIconCartBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M18.404 13.094c1.004 0 1.596-1.127 1.596-2.243V6.525H8.412l-.45-1.781C7.85 4.304 7.478 4 7.054 4H4v2.02h2.253l1.582 6.377-.862 4.975a2.124 2.124 0 0 0-.025.326c0 1.256.916 2.26 2.045 2.26s2.045-.914 2.045-2.169c0-.087-.014-.149-.023-.149h4.875c-.008 0-.023.055-.023.142 0 1.256.916 2.218 2.045 2.218 1.13 0 2.045-.936 2.045-2.19 0-1.255-.916-2.19-2.045-2.19H9.704l.434-2.526h8.266Z" clipRule="evenodd" />
        </svg>
    );
};
